import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { getBuyRentTextForPlayer } from '../../../utils/buy-button-texts/buy-button-texts';
import Button, { SKINS } from '../button/button';
import { withTranslation } from '@wix/yoshi-flow-editor';

function PurchaseButton({
  channel,
  video,
  currentSiteUser,
  onClick = _.noop,
  skin,
  className,
  t,
  i18n: { language },
}) {
  const text = getBuyRentTextForPlayer(
    {
      channelData: channel,
      videoItem: video,
      currentSiteUser,
    },
    t,
    language,
  );

  const handleClick = () => onClick(video);

  if (!text) {
    return null;
  }

  return (
    <Button onClick={handleClick} skin={skin} className={className}>
      {text}
    </Button>
  );
}

PurchaseButton.propTypes = {
  video: PropTypes.object.isRequired,
  channel: PropTypes.object.isRequired,
  currentSiteUser: PropTypes.object,
  i18n: PropTypes.object,
  onClick: PropTypes.func,
  t: PropTypes.func,
  className: PropTypes.string,
};

export { SKINS };
export default withTranslation()(PurchaseButton);
